module.exports = __webpack_public_path__ + "img/Somalia.8920e372.png";